<template>
  <div>
    <Bullet
      ref="bullet_2"
      :e-height="84"
      :top="280"
      :show-count="3"
      :right-time="1.08"
      :bottom-time="1.08"
      style="transform: scale(1);transform-origin: top right;z-index:10;"
    />
    <Bullet
      ref="bullet_1"
      :e-height="55"
      :top="600"
      :show-count="5"
      style="transform: scale(1);transform-origin: top right;z-index:10;"
    />
    <div v-if="mode === 'dark'" class="mask"></div>
  </div>
</template>

<script>
import Vue from 'vue'
import format from 'date-fns/format'
import { Stack, InteralList } from './util.js'
import Bullet from '~/components/Bullet/container.vue'
import dynamicBullet from '~/components/Bullet/dynamic-bullet.vue'
import updateBullet from '~/components/Bullet/update-bullet.vue'

import {
  getStatisticsDynamicBarrage,
  getStatisticsProjectBarrage
} from '~/api/common.api'

export default {
  name: 'BulletTest',
  components: {
    Bullet
  },
  props: {
    companyId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      interalList: new InteralList(),
      stackDynamic: new Stack(),
      stackUpdate: new Stack(),
      timeDynamic: '',
      timeUpdate: '',
      dynamicPageNo: 1,
      dynamicPageSize: 5,
      updatePageNo: 1,
      updatePageSize: 5
    }
  },
  computed: {
    mode() {
      return this.$store.state.config.mapDarkmode ? 'dark' : 'normal'
    },
    count() {
      if (this.$_thebox.clientHeight > 1040) {
        return 4
      }
      if (
        this.$_thebox.clientHeight > 885 &&
        this.$_thebox.clientHeight <= 1040
      ) {
        return 3
      }
      if (this.$_thebox.clientHeight <= 885) {
        return 2
      }
      return 0
    }
  },

  beforeMount() {},
  mounted() {
    this.insertUpdate()
    setTimeout(() => {
      this.insertDynamic()
    }, 300)
  },

  beforeDestroy() {
    this.interalList.drop()
  },
  methods: {
    initDynamic({ name, time, avatar }) {
      return new Vue({
        render: (h) =>
          h(dynamicBullet, {
            props: { name, time, avatar, mode: this.mode }
          })
      })
    },
    initUpdate({
      name,
      time,
      avatar,
      eventContent,
      targetType,
      roleName,
      nickName,
      score
    }) {
      return new Vue({
        render: (h) =>
          h(updateBullet, {
            props: {
              mode: this.mode,
              name,
              time,
              avatar,
              eventContent,
              targetType,
              roleName,
              nickName,
              score
            }
          })
      }).$mount()
    },
    insertDynamic() {
      const iterator = this.stackDynamic[Symbol.iterator]()
      const insert = this.$refs.bullet_1.insertBullet

      // 栈进行操作,当栈的深度小于3时候获取数据
      this.interalList.add(
        'bullet_1',
        async () => {
          if (this.stackDynamic.getStackLength() <= 3) {
            const res = await this.loadDynamicData()
            this.stackDynamic.addMulti(res.data)
          }
          const res = iterator.next()
          const value = res.value

          if (!value || !value.nickname || !value.eventContent || !value.avatar)
            return
          insert(
            this.initDynamic({
              name: value.nickname,
              time: value.eventContent,
              avatar: value.avatar,
              mode: this.mode
            })
          )
        },
        2000,
        true
      )
    },
    insertUpdate() {
      const iterator = this.stackUpdate[Symbol.iterator]()
      const insert = this.$refs.bullet_2.insertBullet
      this.interalList.add(
        'bullet_2',
        async () => {
          if (this.stackUpdate.getStackLength() <= 3) {
            const res = await this.loadUpdateData()
            this.stackUpdate.addMulti(res.data)
          }
          const res = iterator.next()
          const value = res.value
          if (!value || !value.nickname || !value.eventContent || !value.avatar)
            return

          insert(
            this.initUpdate({
              name: value.nickname,
              time: value.eventTime,
              avatar: value.avatar,
              targetType: value.targetType,
              roleName: value.roleName,
              nickName: value.nickname,
              score: value.score,
              eventContent: value.eventContent
            })
          )
        },
        2000,
        true
      )
    },
    async loadDynamicData() {
      if (this.dynamicPageNo === 1) {
        this.timeDynamic = format(new Date(), 'yyyy-MM-dd HH:mm:ss')
      }
      const res = await getStatisticsDynamicBarrage({
        companyId: this.companyId,
        pageNo: this.dynamicPageNo,
        pageSize: this.dynamicPageSize,
        selectTime: this.timeDynamic
      })
      this.dynamicPageNo = this.dynamicPageNo + 1
      if (res && res.data && res.data.length < this.dynamicPageSize) {
        this.dynamicPageNo = 1
      }
      return res
    },
    async loadUpdateData() {
      if (this.updatePageNo === 1) {
        this.timeUpdate = format(new Date(), 'yyyy-MM-dd HH:mm:ss')
      }
      const res = await getStatisticsProjectBarrage({
        companyId: this.companyId,
        pageNo: this.updatePageNo,
        pageSize: this.updatePageSize,
        selectTime: this.timeUpdate
      })
      this.updatePageNo = this.updatePageNo + 1
      if (res && res.data && res.data.length < this.dynamicPageSize) {
        this.updatePageNo = 1
      }
      return res
    }
  }
}
</script>

<style lang="scss" scoped>
.mask {
  position: absolute;
  width: 300px;
  top: 0px;
  bottom: 0px;
  right: 0px;
  background: linear-gradient(90deg, #000000 0%, rgba(0, 0, 0, 0) 100%);
  z-index: 3;
}
</style>
